import {
  LayoutSidebarFinanceRates,
  LayoutSidebarWorkTypes,
} from './components';
import useLayoutSidebar from './useLayoutSidebar';

export interface EnquiryLayoutSidebarProps {
  isLoading?: boolean;
}

const EnquiryLayoutSidebar: React.FunctionComponent<EnquiryLayoutSidebarProps> =
  function ({ isLoading: inputIsLoading = false }) {
    const { workTypes, financeRates, isLoading } =
      useLayoutSidebar(inputIsLoading);
    return (
      <div className="flex flex-1 flex-col gap-y-6 px-6 md:px-8 lg:px-10 xl:px-15 py-10 lg:pt-20 bg-neutral-200">
        <LayoutSidebarWorkTypes workTypes={workTypes} isLoading={isLoading} />
        <LayoutSidebarFinanceRates
          financeRates={financeRates}
          isLoading={isLoading}
        />
      </div>
    );
  };

export default EnquiryLayoutSidebar;
